import { render, staticRenderFns } from "./cardBalanceDetail.vue?vue&type=template&id=4bd881d9&scoped=true&"
import script from "./cardBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./cardBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardBalanceDetail.vue?vue&type=style&index=0&id=4bd881d9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd881d9",
  null
  
)

export default component.exports